module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px",
      "model": _vm.blacklistedOriginator
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Originator"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Originator"
    },
    model: {
      value: (_vm.blacklistedOriginator.originator),
      callback: function($$v) {
        _vm.$set(_vm.blacklistedOriginator, "originator", $$v)
      },
      expression: "blacklistedOriginator.originator"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.saving,
      "plain": ""
    },
    on: {
      "click": _vm.blacklistOriginator
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f9f80df","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/blacklist/BlacklistOriginatorEdit.vue
// module id = 3278
// module chunks = 3